import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import PersonSelectionModal from './PersonSelectionModal';

const ConstructionPermissionApp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {}; 

  const [view, setView] = useState('list'); // 'list' or 'form'
  const [searchTerm, setSearchTerm] = useState('');
  
  // Person Modal State
  const [showPersonModal, setShowPersonModal] = useState(false);
  const [activePersonField, setActivePersonField] = useState(null); // 'applicant' or 'owner'

  const [formData, setFormData] = useState({
    applicationNo: '',
    applicationNoManual: '',
    applicantName: '',
    ownerName: '',
    propertyNo: '',
    roadName: '',
    area: '',
    constructionType: '',
    drainageInfo: '',
    roomDimensions: '',
    numberOfRooms: '',
    afterRoofConstruction: '',
    openSpace: '',
    southBoundary: '',
    northBoundary: '',
    westBoundary: '',
    eastBoundary: ''
  });

  // Mock data
  const [applications, setApplications] = useState([
     // Example data
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const openPersonModal = (field) => {
    setActivePersonField(field);
    setShowPersonModal(true);
  };

  const handlePersonSelect = (person) => {
    if (activePersonField === 'applicant') {
        setFormData(prev => ({ ...prev, applicantName: person.fullName }));
    } else if (activePersonField === 'owner') {
        setFormData(prev => ({ ...prev, ownerName: person.fullName }));
    }
  };

  const handleSave = () => {
    console.log("Saving Application:", formData);
    // Add validation logic here
    setApplications(prev => [...prev, { ...formData, id: Date.now() }]);
    resetForm();
    setView('list');
  };

  const handleCancel = () => {
    setView('list');
    resetForm();
  };

  const resetForm = () => {
    setFormData({
        applicationNo: '',
        applicationNoManual: '',
        applicantName: '',
        ownerName: '',
        propertyNo: '',
        roadName: '',
        area: '',
        constructionType: '',
        drainageInfo: '',
        roomDimensions: '',
        numberOfRooms: '',
        afterRoofConstruction: '',
        openSpace: '',
        southBoundary: '',
        northBoundary: '',
        westBoundary: '',
        eastBoundary: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#267c77] rounded-lg shadow-sm p-4 flex justify-between items-center text-white">
            <div>
                 <h1 className="text-xl font-bold">
                    बांधकाम परवानगी अर्ज यादी
                 </h1>
            </div>
            <div className="flex gap-2">
                 <button 
                   onClick={() => navigate('/asthapan/certificates', { state: location.state })}
                   className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                 >
                   मागे जा
                 </button>
                 {view === 'list' && (
                   <button 
                     onClick={() => setView('form')}
                     className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition"
                   >
                     नविन
                   </button>
                 )}
            </div>
        </div>
      </div>

      {view === 'list' ? (
        /* LIST VIEW */
        <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          
          {/* Search Bar */}
          <div className="p-4 border-b border-gray-200 flex gap-4">
             <div className="relative flex-1">
                <input 
                  type="text" 
                  placeholder="अर्जदाराचे नाव" 
                  className="w-full px-4 py-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
             </div>
             <button className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition">
                शोधणे
             </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#267c77] text-white">
                  <th className="p-3 border-r border-white/30 font-medium text-center">अर्ज क्रमांक</th>
                  <th className="p-3 border-r border-white/30 font-medium text-center">अर्जदाराचे नाव</th>
                  <th className="p-3 font-medium text-center">पर्याय</th>
                </tr>
              </thead>
              <tbody>
                {applications.length === 0 ? (
                    <tr>
                        <td colSpan="3" className="p-4 text-center text-gray-500">
                            No records found
                        </td>
                    </tr>
                ) : (
                    applications.map((app, idx) => (
                        <tr key={idx} className="hover:bg-gray-50 border-b">
                            <td className="p-3 border-r text-center">{app.applicationNoManual || app.applicationNo}</td>
                            <td className="p-3 border-r">{app.applicantName}</td>
                            <td className="p-3 text-center flex justify-center gap-2">
                                {/* Options */}
                            </td>
                        </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

           {/* Pagination */}
           <div className="p-2 border-t bg-[#267c77] text-white flex justify-center items-center gap-2">
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">|&lt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&lt;&lt;</button>
                <span className="px-3 py-1 bg-white/20 rounded text-sm bg-[#1e6b66]">1</span>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;&gt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;|</button>
                <select className="ml-2 bg-white text-black text-sm p-1 rounded">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                </select>
           </div>
        </div>
      ) : (
        /* FORM VIEW */
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 border-t-4 border-[#267c77]">
             <div className="mb-6 border-b pb-2">
                 <h2 className="text-xl font-medium text-white bg-[#267c77] inline-block px-4 py-1 rounded-t-lg w-full">बांधकाम परवानगी अर्ज</h2>
             </div>
            <div className="space-y-4">
                
                {/* Application No (Auto + Manual) */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">अर्ज क्र.:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="applicationNo"
                            value={formData.applicationNo}
                            onChange={handleInputChange}
                            placeholder="अर्ज क्र."
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-100"
                            readOnly
                         />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">अर्ज नं. :</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="applicationNoManual"
                            value={formData.applicationNoManual}
                            onChange={handleInputChange}
                            placeholder="अर्ज नं. भरा."
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                 {/* Applicant Name */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">अर्जदाराचे नाव:</label>
                    <div className="md:col-span-3 flex gap-0">
                         <input 
                            type="text"
                            name="applicantName"
                            value={formData.applicantName}
                            onChange={handleInputChange} 
                            placeholder="व्यक्तीचे नाव"
                            className="flex-1 p-2 border border-[#267c77]/30 rounded-l focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-100"
                         />
                         <button 
                            onClick={() => openPersonModal('applicant')}
                            className="px-4 bg-[#267c77] text-white rounded-r hover:bg-[#1e6b66]"
                        >
                            ...
                         </button>
                    </div>
                </div>

                {/* Owner Name */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">मालकाचे नाव:</label>
                    <div className="md:col-span-3 flex gap-0">
                         <input 
                            type="text"
                            name="ownerName"
                            value={formData.ownerName}
                            onChange={handleInputChange} 
                            placeholder="व्यक्तीचे नाव"
                            className="flex-1 p-2 border border-[#267c77]/30 rounded-l focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-100"
                         />
                         <button 
                             onClick={() => openPersonModal('owner')}
                            className="px-4 bg-[#267c77] text-white rounded-r hover:bg-[#1e6b66]"
                        >
                            ...
                         </button>
                    </div>
                </div>

                 {/* Property Number */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1"> मिळकत क्र.:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="propertyNo"
                            value={formData.propertyNo}
                            onChange={handleInputChange}
                            placeholder="मिळकत क्र. भरा."
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Road Name */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">रस्त्याचे नाव:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="roadName"
                            value={formData.roadName}
                            onChange={handleInputChange}
                            placeholder="रस्त्याचे नाव भरा."
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Area (Kshetrafal) */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">क्षेत्रफळ:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="area"
                            value={formData.area}
                            onChange={handleInputChange}
                            placeholder="क्षेत्रफळ भरा."
                            className="w-1/2 p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Row 1: Construction Type & Drainage */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium">बांधकाम प्रकार:</label>
                    <div>
                         <input 
                            type="text" 
                            name="constructionType"
                            value={formData.constructionType}
                            onChange={handleInputChange}
                            placeholder="बांधकाम प्रकार भरा."
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>

                    <label className="text-gray-700 font-medium text-right md:text-left lg:text-right">ड्रेनेज बाबत:</label>
                    <div>
                         <input 
                            type="text" 
                            name="drainageInfo"
                            value={formData.drainageInfo}
                            onChange={handleInputChange}
                            placeholder="ड्रेनेज बाबत"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Row 2: Room Dimensions & No of Rooms */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium">खोल्याचे माप:</label>
                    <div>
                         <input 
                            type="text" 
                            name="roomDimensions"
                            value={formData.roomDimensions}
                            onChange={handleInputChange}
                            placeholder="खोल्याचे माप"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>

                    <label className="text-gray-700 font-medium text-right md:text-left lg:text-right">खोल्यांची संख्या:</label>
                    <div>
                         <input 
                            type="text" 
                            name="numberOfRooms"
                            value={formData.numberOfRooms}
                            onChange={handleInputChange}
                            placeholder="खोल्यांची संख्या"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Row 3: After Roof & Open Space */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium">छप्पर बांधकामानंतर:</label>
                    <div>
                         <input 
                            type="text" 
                            name="afterRoofConstruction"
                            value={formData.afterRoofConstruction}
                            onChange={handleInputChange}
                            placeholder="छप्पर बांधकामानंतर"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>

                    <label className="text-gray-700 font-medium text-right md:text-left lg:text-right">खुली जागा:</label>
                    <div>
                         <input 
                            type="text" 
                            name="openSpace"
                            value={formData.openSpace}
                            onChange={handleInputChange}
                            placeholder="खुली जागा"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                 {/* Boundaries */}
                 <div className="space-y-4">
                     {/* South */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                        <label className="text-gray-700 font-medium md:col-span-1">दक्षिण:</label>
                        <div className="md:col-span-3">
                            <input 
                                type="text" 
                                name="southBoundary"
                                value={formData.southBoundary}
                                onChange={handleInputChange}
                                placeholder="दक्षिण सीमा माहिती"
                                className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                            />
                        </div>
                    </div>
                    {/* West */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                        <label className="text-gray-700 font-medium md:col-span-1">पश्चिम:</label>
                        <div className="md:col-span-3">
                            <input 
                                type="text" 
                                name="westBoundary"
                                value={formData.westBoundary}
                                onChange={handleInputChange}
                                placeholder="पश्चिम सीमा माहिती"
                                className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                            />
                        </div>
                    </div>
                    {/* North */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                        <label className="text-gray-700 font-medium md:col-span-1">उत्तर:</label>
                        <div className="md:col-span-3">
                            <input 
                                type="text" 
                                name="northBoundary"
                                value={formData.northBoundary}
                                onChange={handleInputChange}
                                placeholder="उत्तर सीमा माहिती"
                                className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                            />
                        </div>
                    </div>
                    {/* East */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                        <label className="text-gray-700 font-medium md:col-span-1">पूर्व:</label>
                        <div className="md:col-span-3">
                            <input 
                                type="text" 
                                name="eastBoundary"
                                value={formData.eastBoundary}
                                onChange={handleInputChange}
                                placeholder="पूर्व सीमा माहिती"
                                className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                            />
                        </div>
                    </div>
                 </div>

            </div>

             {/* Footer Buttons */}
             <div className="mt-8 flex justify-center gap-4 py-4 bg-[#267c77] rounded-b-lg -mx-6 -mb-6">
                <button 
                  onClick={handleSave}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    साठविणे
                </button>
                <button 
                  onClick={handleCancel}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition font-medium"
                >
                    रद्द करणे
                </button>
             </div>
        </div>
      )}

      {/* Person Selection Modal */}
      <PersonSelectionModal 
        isOpen={showPersonModal}
        onClose={() => setShowPersonModal(false)}
        onSelect={handlePersonSelect}
      />
    </div>
  );
};

export default ConstructionPermissionApp;
